(function (window) {
  'use strict';

  const subscribe = document.querySelector('.js-subscribe-form');
  const subscribeInput = document.querySelector('.js-subscribe-form-input');
  const focusedSubscribeClass = 'js-subscribe-form--focused';
  const successStatusClass = 'js-subscribe-form--success';
  const errorStatusClass = 'js-subscribe-form--error';

  function subscribeFocus(e) {
    // This class is not removed on blur because that prevents the ability to
    // click links within this text.
    subscribe.classList.add(focusedSubscribeClass);
  }

  function statusClose(e) {
    subscribe.classList.remove(successStatusClass, errorStatusClass);
  }

  if (subscribe && subscribeInput) {
    const statusCloseButton = subscribe.querySelector('.js-subscribe-status-close-button');

    subscribeInput.addEventListener('focus', subscribeFocus);
    statusCloseButton.addEventListener('click', statusClose);
  }

})(this);
